<template>
  <w-icon-wrapper
    :height="23.2"
    :width="23.704"
    view-box="0 0 23.704 23.2"
    icon-name="work-ordered-icon"
  >
    <g
      id="_94_Reserviert"
      data-name="94 Reserviert"
      transform="translate(-304.296 -439)"
    >
      <g
        id="Gruppe_25627"
        data-name="Gruppe 25627"
        transform="translate(273.732 438.808)"
      >
        <path
          id="Pfad_55849"
          data-name="Pfad 55849"
          d="M53.872,9.844a6.525,6.525,0,0,0-3.9-3.342,3.484,3.484,0,0,0,1.42-2.79,3.622,3.622,0,0,0-7.241,0,3.484,3.484,0,0,0,1.42,2.79,6.525,6.525,0,0,0-3.9,3.342,5.685,5.685,0,0,0-.395,1.094,9.8,9.8,0,0,0,.991.694,10.506,10.506,0,0,0,11.017,0,9.933,9.933,0,0,0,.992-.694A5.756,5.756,0,0,0,53.872,9.844ZM45.261,3.712a2.507,2.507,0,0,1,5.013,0,2.507,2.507,0,0,1-5.013,0Zm1.664,3.581.533,1.333L46.7,12.042a9.27,9.27,0,0,1-4.134-1.505A5.52,5.52,0,0,1,46.925,7.293Zm.842,4.815h0Zm1.069-.066-.759-3.416.533-1.333a5.52,5.52,0,0,1,4.36,3.244A9.27,9.27,0,0,1,48.836,12.042Z"
          fill="currentColor"
        />
        <g
          id="Gruppe_25626"
          data-name="Gruppe 25626"
        >
          <path
            id="Pfad_55850"
            data-name="Pfad 55850"
            d="M44.529,23.392V19.6H30.6v3.79h1.93V21.6h4.02v1.79h1.93V21.6H42.6v1.79Z"
            fill="currentColor"
          />
          <rect
            id="Rechteck_4055"
            data-name="Rechteck 4055"
            width="6"
            height="6"
            transform="translate(35.564 12.274)"
            fill="currentColor"
          />
          <rect
            id="Rechteck_4056"
            data-name="Rechteck 4056"
            width="3.765"
            height="3.765"
            transform="translate(30.564 14.51)"
            fill="currentColor"
          />
          <rect
            id="Rechteck_4057"
            data-name="Rechteck 4057"
            width="2.006"
            height="2.006"
            transform="translate(42.56 16.268)"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconOrdered' };
</script>
